import request from '@/utils/request'

let Advertising_spaceApi = {

  /*广告位设置列表*/
  list(data) {
    return request._post('/shop/plus.advertising_space.Index/index', data);
},
/*添加广告位设置*/
add(data) {
    return request._post('/shop/plus.advertising_space.Index/add', data);
},
/*修改广告位设置*/
edit(data) {
    return request._post('/shop/plus.advertising_space.Index/edit', data);
},
/*删除广告位设置*/
del(data) {
    return request._post('/shop/plus.advertising_space.Index/del', data);
},
/*广告位设置详情*/
detail(data) {
  return request._post('/shop/plus.advertising_space.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.advertising_space.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.advertising_space.Setting/getSetting', data, errorback);
    },
}
export default Advertising_spaceApi;



// WEBPACK FOOTER //
// ./src/api/advertising_space.js